import { createSelectorHook } from 'react-redux';
import { RootState } from 'store/types';

export { shallowEqual, useDispatch } from 'react-redux';
export const useSelector = createSelectorHook<RootState>();
